import PropTypes from "prop-types";
import * as React from "react";
import css from "./ProductButton.module.css";

const ProductButton = React.forwardRef(function ProductButton(
  { children, className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      className={[css.root, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </button>
  );
});

ProductButton.displayName = "ProductButton";

ProductButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ProductButton;
